

// YouTubeのiframe apiの読み込み
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
// YouTubeの埋め込み
function onYouTubeIframeAPIReady() {
  ytPlayer = new YT.Player(
    'youtube',
    {
      videoId: 'MV-UDEHXqow', // YouTubeのvideoidを入れる
		events: {
			'onReady': function(evt) {
				evt.target.mute();
				evt.target.playVideo();
		},
		'onStateChange': function(evt) {
			switch (evt.data) {
				case YT.PlayerState.ENDED:
				  evt.target.playVideo();
				  break;
			}
		}
		},
		playerVars: {
			'playsinline': 1,
			'loop': 1,
			'autoplay': 1,
			'playlist': 'MV-UDEHXqow',
			'rel':0,
			'mute': 1,
			'controls': 0 
		}
    }
  );
}
function onPlayerReady(event) {
  event.target.mute();
}

$(function() {
	$('#playbtn').click(function(){
		$('#playbtn').hide();
		$('.movie .cover').hide();
		ytPlayer.unMute();
		ytPlayer.playVideo(); 
	});
	

})